module.exports = __webpack_public_path__ + "static/mo23-2d185571f75f6da372432d02452720a4.png";